import { FabNavItem } from '@fabric/components/common';

export const appNavItems: FabNavItem[] = [
    {
        name: 'Inicio',
        route: '/home',
        iconName: 'home'
    },
    {
        name: 'Crear Remito',
        route: '/create-remito',
        iconName: 'create'
    },
    {
        name: 'Todos los Remitos',
        route: '/view-remito',
        iconName: 'search'
    },
    {
      name: 'MGO Errores',
      route: '/mgo-error-processing',
      iconName: 'autorenew'
    },
    {
      name: 'Remitos Emitidos',
      route: '/issued-remitos-report',
      iconName: 'description'
    },
    {
      name: 'Remitos A Retornar',
      route: '/free_open_remitos',
      iconName: 'description'
    },
    {
        name: 'Mantenimiento',
        iconName: 'view_list',
        subItems: [
            {
              name: 'Destinatario',
              route: '/destinatario-maintenance',
              iconName: 'move_down'
            },
            {
              name: 'Dock',
              route: '/dock-maintenance',
              iconName: 'move_down'
            },
            {
              name: 'Motivos Despacho',
              route: '/reason-code-maintenance',
              iconName: 'move_down'
            },
            {
              name: 'Solicitante',
              route: '/solicitante-maintenance',
              iconName: 'group'
            },
            {
              name: 'Transporte',
              route: '/transporte-maintenance',
              iconName: 'move_down'
            },
            {
              name: 'Usuario',
              route: '/user-maintenance',
              iconName: 'group'
            },
          {
            name: 'Scheduled Tasks',
            route: '/scheduled-task-status',
            iconName: 'event'
          },
        ]
    }
];
